import React from 'react';
import { Box, VStack } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { Option } from 'types/general.types';
import { InputField } from 'app/components/Core';

import { AuddlySignUpFormFields } from 'app/components/AuddlySignUp/AuddlySignUpForm';
import { MarketingCheckbox } from 'app/components/SignUp/MarketingCheckbox';
import { ChakraAutocompleteField } from 'app/components/Core/ChakraAutocompleteField/ChakraAutocompleteField';

export interface AuddlySignUpLocationFormProps {
  countries: Option[];
}

export const AuddlySignUpLocationForm = ({
  countries,
}: AuddlySignUpLocationFormProps) => {
  const {
    formState: { errors },
    register,
    control,
  } = useFormContext<AuddlySignUpFormFields>();

  return (
    <VStack>
      <Box w="full">
        <InputField
          label="City"
          {...register('city')}
          isInvalid={Boolean(errors.city)}
          errorMessage={errors.city?.message}
        />
      </Box>
      <Box w="full" style={{ marginTop: '16px' }}>
        <ChakraAutocompleteField
          control={control}
          label="Country"
          name="country"
          options={countries}
          isClearable
          dataTestId="country"
        />
      </Box>
      <MarketingCheckbox<AuddlySignUpFormFields> name="emailOptIn" />
    </VStack>
  );
};
